import React from "react";
import CircleIcon from "@mui/icons-material/FiberManualRecord";
import {Equipment} from "../../componentObjects";

const DIAGNOSTIC_PROPS = [
    "shType",
    "ShCtRangesAdc",
    "ShCtsInstalledAdc",
    "batteryVoltage"
];

const DIAGNOSTIC_STRINGS = {
    SH_TYPE: "shType",
    SH_CT_RANGES_ADC: "ShCtRangesAdc",
    SH_CTS_INSTALLED_ADC: "ShCtsInstalledAdc",
    BATTERY_VOLTAGE: "batteryVoltage",
    OSH: "OSH",
    ISH: "ISH"
}

const DIAGNOSTIC_ACTIONS = {
    ShIdentity: {
        name: "Sensor Hub Identity",
        action: "Replace Sensor Hub"
    },
    CtInstallError: {
        name: "CT Install Error",
        action: <div>1. Check "C" connection: <br/>
            &nbsp;&nbsp;&nbsp;&nbsp; a. ISH: Check that RC harness is fully plugged in <br/>
            &nbsp;&nbsp;&nbsp;&nbsp; b. OSH: Check that "C" CT is fully plugged in <br/>
            2. Check that measurement CT is fully plugged in <br/>
            3. If above steps do not resolve problem, then replace sensor hub
        </div>
    },
    CtRangeError: {
        name: "CT Range Error",
        action: <div>1. Make sure appropriate CT is installed (50A for OSH, 20A for ISH)<br/>
            2. Check "C" connection: <br/>
            &nbsp;&nbsp;&nbsp;&nbsp; a. ISH: Check that RC harness is fully plugged in <br/>
            &nbsp;&nbsp;&nbsp;&nbsp; b. OSH: Check that "C" CT is fully plugged in <br/>
            3. Check that measurement CT is fully plugged in <br/>
            4. If device is OSH and above steps did not resolve problem, replace 50A measurement CT <br/>
            5. If above steps do not resolve problem, then replace sensor hub
        </div>
    },
    OshBatteryProblem: {
        name: "Osh Battery Problem",
        action: <div>1. Check that both CTs are fully plugged in <br/>
            2. Open battery door and make sure that batteries are oriented correctly and are fully plugged in. <br/>
            3. If problem is not resolved then replace batteries <br/>
            4. If above steps do not resolve the problem, then replace sensor hub
        </div>
    },
    IshPowerProblem: {
        name: "Ish Power Problem",
        action: <div>1. Verify RC harness wiring. <br/>
            2. Verify RC harness input voltage (20 – 30VAC) <br/>
            3. Verify RC harness and CT are both fully plugged in <br/>
            4. If above steps do not resolve the problem, then replace sensor hub
        </div>
    }
}

function DiagnosticsTestModal({ show, onClick, assetType, isFlycatcher, properties }) {
    let diagnosticProps = properties !== null && properties !== undefined ? properties.filter(p => DIAGNOSTIC_PROPS.includes(p.name)) : [];
    
    const checkIdentity = () => {
        let shType = diagnosticProps.findIndex(x => x.name === DIAGNOSTIC_STRINGS.SH_TYPE) !== -1 ? diagnosticProps.find(x => x.name === DIAGNOSTIC_STRINGS.SH_TYPE) : null;
        if (shType !== null) {
            if ((assetType === Equipment.FURNACE || assetType === Equipment.AIR_HANDLER) && shType === DIAGNOSTIC_STRINGS.OSH) {
                return false;
            }
            else if ((assetType === Equipment.AIR_CONDITIONER || assetType === Equipment.HEAT_PUMP) && shType === DIAGNOSTIC_STRINGS.ISH) {
                return false;
            }
            else {
                return true;
            }
        }
        else {
            return false;
        }
    }
    
    const checkCtErrors = () => {
        let shCtsInstalledAdc = diagnosticProps.findIndex(x => x.name === DIAGNOSTIC_STRINGS.SH_CTS_INSTALLED_ADC) !== -1 ? diagnosticProps.find(x => x.name === DIAGNOSTIC_STRINGS.SH_CTS_INSTALLED_ADC) : null;
        if (shCtsInstalledAdc !== null) {
            if (shCtsInstalledAdc > -1920) {
                return false;
            }
            else {
                return true;
            }
        }
        else {
            return false;
        }
    }
    
    const checkCtRanges = () => {
        let shCtRangesAdc = diagnosticProps.findIndex(x => x.name === DIAGNOSTIC_STRINGS.SH_CT_RANGES_ADC) !== -1 ? diagnosticProps.find(x => x.name === DIAGNOSTIC_STRINGS.SH_CT_RANGES_ADC) : null;
        if (shCtRangesAdc !== null && (assetType === Equipment.AIR_CONDITIONER || assetType === Equipment.HEAT_PUMP)) {
            if (shCtRangesAdc < -115 || shCtRangesAdc > 141) {
                return false;
            }
            else {
                return true;
            }
        }
        else if (!(assetType === Equipment.AIR_CONDITIONER || assetType === Equipment.HEAT_PUMP)) {
            return true;
        }
        else {
            return false;
        }
    }
    
    const checkOshBattery = () => {
        if (assetType === Equipment.AIR_CONDITIONER || assetType === Equipment.HEAT_PUMP) {
            let batteryVoltage = diagnosticProps.findIndex(x => x.name === DIAGNOSTIC_STRINGS.BATTERY_VOLTAGE) !== -1 ? diagnosticProps.find(x => x.name === DIAGNOSTIC_STRINGS.BATTERY_VOLTAGE) : null;
            if (batteryVoltage !== null) {
                if (batteryVoltage >= 4.4) {
                    return false;
                }
                else {
                    return true;
                }
            }
            else {
                return false;
            }
        }
        else {
            return true;
        }
    }
    
    const checkIshPower = () => {
        if (assetType === Equipment.FURNACE || assetType === Equipment.AIR_HANDLER) {
            let batteryVoltage = diagnosticProps.findIndex(x => x.name === DIAGNOSTIC_STRINGS.BATTERY_VOLTAGE) !== -1 ? diagnosticProps.find(x => x.name === DIAGNOSTIC_STRINGS.BATTERY_VOLTAGE) : null;
            if (batteryVoltage !== null) {
                if (batteryVoltage < 4.4 && !isFlycatcher) { 
                    return false;
                }
                else {
                    return true;
                }
            }
            else {
                return false;
            }
        }
        else {
            return true;
        }
    }
    
    const getIcon = (isGreen) => {
        if (isGreen) {
            return (<span className={"circle-wrapper"}>
                            <CircleIcon className={"pad-5 color-green"} />
                        </span>);
        }
        else {
            return (<span className={"circle-wrapper"}>
                            <CircleIcon className={"pad-5 color-red"} />
                        </span>);
        }
    }
    
    return (
        <div className="modal" style={{display: show ? "block" : "none"}}>
            <div className="modal-wrapper"
                 style={{
                     transform: show ? 'translateY(0vh)' : 'translateY(-100vh)',
                     opacity: show ? '1' : '0'
                 }}>

                <div className="modal-header">
                    <h3>Diagnostic Test</h3>
                    <span className="close-modal-btn" onClick={() => onClick()}>×</span>
                </div>
                
                <br/>
                <div className={"margin-0-20"}>
                    <table className={"width-100p margin-bottom-0"}>

                        <thead>
                        <tr className="alerts-table-row">
                            <th className="table-shrink text-center">
                                TEST
                            </th>
                            <th className="table-shrink text-center">
                                RESULT
                            </th>
                            <th className="table-shrink pad-left-10">
                                ACTION
                            </th>
                        </tr>
                        </thead>

                        <tbody>
                            <tr className="alerts-table-row">
                                <td className={"border-left text-center"}>{DIAGNOSTIC_ACTIONS.ShIdentity.name}</td>
                                <td className={"text-center"}>{getIcon(checkIdentity())}</td>
                                <td className={"border-right"}>{checkIdentity() ? 'None' : DIAGNOSTIC_ACTIONS.ShIdentity.action}</td>
                            </tr>

                            <tr className="alerts-table-row">
                                <td className={"border-left text-center"}>{DIAGNOSTIC_ACTIONS.CtInstallError.name}</td>
                                <td className={"text-center"}>{getIcon(checkCtErrors())}</td>
                                <td className={"border-right"}>{checkCtErrors() ? 'None' : DIAGNOSTIC_ACTIONS.CtInstallError.action}</td>
                            </tr>

                            <tr className="alerts-table-row">
                                <td className={"border-left text-center"}>{DIAGNOSTIC_ACTIONS.CtRangeError.name}</td>
                                <td className={"text-center"}>{getIcon(checkCtRanges())}</td>
                                <td className={"border-right"}>{checkCtRanges() ? 'None' : DIAGNOSTIC_ACTIONS.CtRangeError.action}</td>
                            </tr>

                            <tr className="alerts-table-row">
                                <td className={"border-left text-center"}>{DIAGNOSTIC_ACTIONS.OshBatteryProblem.name}</td>
                                <td className={"text-center"}>{getIcon(checkOshBattery())}</td>
                                <td className={"border-right"}>{checkOshBattery() ? 'None' : DIAGNOSTIC_ACTIONS.OshBatteryProblem.action}</td>
                            </tr>

                            <tr className="alerts-table-row">
                                <td className={"border-left text-center"}>{DIAGNOSTIC_ACTIONS.IshPowerProblem.name}</td>
                                <td className={"text-center"}>{getIcon(checkIshPower())}</td>
                                <td className={"border-right"}>{checkIshPower() ? 'None' : DIAGNOSTIC_ACTIONS.IshPowerProblem.action}</td>
                            </tr>
                        </tbody>
                    </table>
                </div>
                <br/>
                <br/>
            </div>
        </div>
    );
}

export default DiagnosticsTestModal;